import React from 'react';
import { Link } from 'react-router-dom';

export default function QuickActionGrid() {
  const quickActions = [
    {
      icon: '💰',
      title: 'My Money',
      subtitle: 'See balance & jobs',
      to: '/allowance'
    },
    {
      icon: '🎯',
      title: 'Activities',
      subtitle: 'Browse fun things',
      to: '/tasks?tab=activities'
    }
  ];

  return (
    <div className="quick-actions">
      {quickActions.map((action, index) => (
        <Link key={index} to={action.to} className="quick-action">
          <div className="action-icon">{action.icon}</div>
          <div className="action-title">{action.title}</div>
          <div className="action-subtitle">{action.subtitle}</div>
        </Link>
      ))}
    </div>
  );
}